import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CompletionConfettiProps {
  trigger: boolean;
}
export function CompletionConfetti({
  trigger
}: CompletionConfettiProps) {
  const [particles, setParticles] = useState<number[]>([]);
  useEffect(() => {
    if (trigger) {
      // Generate random particles
      const newParticles = Array.from({
        length: 20
      }).map((_, i) => i);
      setParticles(newParticles);
      // Cleanup
      const timer = setTimeout(() => setParticles([]), 1000);
      return () => clearTimeout(timer);
    }
  }, [trigger]);
  return <AnimatePresence data-id="element-173">
      {particles.length > 0 && <div className="absolute inset-0 pointer-events-none overflow-hidden flex items-center justify-center z-50" data-id="element-174">
          {particles.map(i => <Particle key={i} index={i} data-id="element-175" />)}
        </div>}
    </AnimatePresence>;
}
function Particle({
  index
}: {
  index: number;
}) {
  const colors = ['#FF6B6B', '#FFD93D', '#6BCF7F', '#A78BFA'];
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  const randomAngle = Math.random() * 360;
  const randomDistance = 50 + Math.random() * 100;
  return <motion.div initial={{
    x: 0,
    y: 0,
    scale: 0,
    opacity: 1
  }} animate={{
    x: Math.cos(randomAngle * (Math.PI / 180)) * randomDistance,
    y: Math.sin(randomAngle * (Math.PI / 180)) * randomDistance,
    scale: [0, 1, 0],
    opacity: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="absolute w-3 h-3 rounded-full" style={{
    backgroundColor: randomColor
  }} data-id="element-176" />;
}